import { jssPreset, StylesProvider } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import AddNewContractModal from 'components/AddNewContractModal';
import Fab from 'components/FabComponent';
import Footer from 'components/Footer';
import Toaster from 'components/Toaster';
import NavBarDashboard from 'containers/NavBarDashboard';
import fflipConfig from 'features/config';
import fflip from 'fflip';
import GATracking from 'helpers/GATracking';
import PrivateRoute from 'helpers/routing/PrivateRoute';
import PublicRoute from 'helpers/routing/PublicRoute';
import TransverseRoute from 'helpers/routing/TransverseRoute';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MuiTheme from 'Material-UI/theme';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteProps, Router, Switch } from 'react-router-dom';
import { ROUTES } from 'routes';
import { history } from 'store';
import { getIsOpenAddNewContractModalSelector } from 'store/contract/selectors';
import { isReverse } from 'helpers/intl';
import SmartBanner from 'components/SmartBanner';
import { MobileView } from 'react-device-detect';
import LanguageProvider from 'store/LanguageProvider';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getUserInfo } from 'store/user/actions';
import styled from 'styled-components';

const GlobalWrapper = styled.div`
  min-height: 93vh;
`;
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const App: React.FC = (): JSX.Element => {
  const lang = useSelector(getLocaleSelector);
  const isOpen = useSelector(getIsOpenAddNewContractModalSelector);
  const reverse = isReverse(lang);
  const direction = reverse ? 'rtl' : 'ltr';

  document.dir = direction;
  fflip.config(fflipConfig);

  useEffect(() => {
    GATracking.init();
    GATracking.pageView();
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (localStorage.getItem('token')) dispatch(getUserInfo());
    // eslint-disable-next-line
  }, []);

  return (
    <ThemeProvider theme={MuiTheme(direction)}>
      <LanguageProvider>
        <StylesProvider jss={jss}>
          <Router history={history}>
            <MobileView>
              <SmartBanner />
            </MobileView>
            <NavBarDashboard />
            <GlobalWrapper>
              <Switch>
                {ROUTES.PRIVATE()
                  .filter((ele) => ele.isVisible)
                  .map((props: RouteProps, idx: number) => (
                    <PrivateRoute key={idx} {...props} />
                  ))}
                {ROUTES.PUBLIC.map((props: RouteProps, idx: number) => (
                  <PublicRoute key={idx} {...props} />
                ))}
                {ROUTES.TRANSVERSE.map((props: RouteProps, idx: number) => (
                  <TransverseRoute key={idx} {...props} />
                ))}
              </Switch>
              <AddNewContractModal isOpen={isOpen} />
              <Toaster />
              <Fab />
            </GlobalWrapper>
            <Footer />
          </Router>
        </StylesProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;
